import { type MutableRefObject } from 'react';
import { type OpenFormActions, type OpenFormState } from './OpenFormReducer.js';
import { OpenFormFetch } from './OpenFormFetch.js';
import { OpenFormFrame } from './OpenFormFrame.js';
import { type OpenFormStore } from './OpenFormStore.js';
import type { OpenFormDraftItem } from '../../generated/api/openFormDraftItem.js';
import type { OpenFormListItem } from '../../generated/api/openFormListItem.js';

export class OpenFormAsync {
  static readonly cache = new Map<string, Promise<unknown>>();
  static readonly draft = new Map<string, OpenFormDraftItem>();
  static readonly fetch = OpenFormFetch(this);
  static readonly flags = new Set<'draft'>(['draft']);
  static readonly forms = new Map<string, OpenFormListItem>();
  static readonly frame = OpenFormFrame(this);

  static actions: OpenFormActions;
  static store: OpenFormStore;
  static #state: MutableRefObject<OpenFormState>;

  static get state(): OpenFormState {
    return this.#state.current;
  }

  static set state(state: MutableRefObject<OpenFormState>) {
    this.#state = state;
  }
}
